import { render, staticRenderFns } from "./alliance.vue?vue&type=template&id=3cbac7de&scoped=true&"
import script from "./alliance.vue?vue&type=script&lang=js&"
export * from "./alliance.vue?vue&type=script&lang=js&"
import style0 from "./alliance.vue?vue&type=style&index=0&id=3cbac7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbac7de",
  null
  
)

component.options.__file = "alliance.vue"
export default component.exports